/*
 * @Date: 2022-05-31 11:57:57
 * @LastEditTime: 2022-05-31 14:24:56
 */
import React, { createContext, useEffect, useReducer, useState } from 'react'
import * as Styles from './Channel.style'
import { IChannelItem } from '../../../../services/Modules/SearchServer'
import Channeltem from '../Channeltem/Channeltem'
import { withRouter, RouterProps } from 'react-router'
interface IProps extends RouterProps {
  data: IChannelItem[]
  keyword: string
}

function Channel(props: IProps) {
  const { data } = props
  const showList = data.slice(0, 3)

  return (
    <div className={Styles.container}>
      <div className={Styles.title}>
        <span className={Styles.bold}>专栏</span>
        <span className={Styles.right} onClick={() => props.history.push(`/more-channel?keyword=${props.keyword}`)}>
          查看更多
          <span className={Styles.arrow} />
        </span>
      </div>
      <div className={Styles.list}>
        {showList.map((item, index) => {
          // todo: 特例，卢文建的课程不可搜索
          if (item.id === 320857) { return <></> }
          return <Channeltem key={index} content={item} />
        })}
      </div>
    </div>
  )
}

export default withRouter(Channel as any) as any



// WEBPACK FOOTER //
// ./src/views/SearchResult/components/Channel/Channel.tsx